// extracted by mini-css-extract-plugin
export var tableHeader = "table-module--tableHeader--1lfJe";
export var gradient = "table-module--gradient--TYrrJ";